module.exports = {"pathContext":{"name":"ClientCareCreditStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CARDHOLDER"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DEFERRED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"PRE_APPROVED"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-client-care-credit-status.json
// module id = 1225
// module chunks = 2417956328179